import {Component, Inject, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {User} from '@app/shared/user.service';

@Component({
    selector: 'frog-user-detail-dialog',
    templateUrl: './user-detail-dialog.component.html',
    styleUrls: ['./user-detail-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class UserDetailDialogComponent implements OnInit {
    public form: UntypedFormGroup;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<UserDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: User,
    ) {
        this.form = this.formBuilder.group({
            name: '',
            avatar: '',
        });
    }

    ngOnInit(): void {
        this.form.setValue({
            name: this.data.name || '',
            avatar: this.data.avatar || '',
        });
    }

    save() {
        this.dialogRef.close(this.form.value);
    }
}
